export const PROPOSAL_CATEGORIES = [
  {
    category_id: 19,
    id: 2785,
    group_id: 4649,
    name: "3 层提案专区",
    thread_count: 0,
    post_count: 0,
    can_see: 1,
    children: [
      { category_id: 12, id: 2483, group_id: 4649, name: "P3 提案", thread_count: 0, post_count: 0, can_see: 1 },
      { category_id: 9, id: 2272, group_id: 4649, name: "P2 提案", thread_count: 0, post_count: 0, can_see: 1 },
      { category_id: 14, id: 2485, group_id: 4649, name: "P1 提案", thread_count: 0, post_count: 0, can_see: 1 },
    ],
  },
];

export const SELECT_WALLET = "SEEDAO_WALLET";

export const Wallet = {
  METAMASK: 'METAMASK',
  UNIPASS: 'UNIPASS',
  JOYID: 'JOYID',
}

export const METAFORO_TOKEN = "METAFORO_TOKEN";
export const SEE_AUTH = "SEE_AUTH";
export const SEEDAO_USER = "SEEDAO_USER";
export const SEEDAO_USER_DATA = "SEEDAO_USER_DATA";